import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
export default {
  name: 'vx-list',
  props: {
    list: {
      type: Array,
      required: true
    },
    icon: {
      type: String,
      default: 'ChevronsRightIcon'
    }
  },
  computed: {
    rtlSpecificIcon: function rtlSpecificIcon() {
      var i = this.icon;

      if (this.$vs.rtl) {
        i.includes('Left') ? i = i.replace('Left', 'Right') : i.includes('Right') ? i = i.replace('Right', 'Left') : null;
      }

      return i;
    }
  }
};